var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
/* eslint-disable no-shadow */
import React from "react";
import classnames from "classnames";
import Switch from "../switch";
import "./style/index.less";
const SwitchFormItem = (_a) => {
    var { label, itemName, form, checked = false, onChangeHandler } = _a, rest = __rest(_a, ["label", "itemName", "form", "checked", "onChangeHandler"]);
    const { getFieldProps, setFieldsValue } = form;
    return (<div className={classnames("ppx-switch-item")}>
      <div className={classnames("title")}>{label}</div>
      <Switch {...rest} {...getFieldProps(itemName, {
        initialValue: checked,
        valuePropName: "checked",
    })} color={rest.color || "#4A7EFE"} onClick={(val) => {
        if (onChangeHandler) {
            onChangeHandler(val);
        }
        setFieldsValue({
            [itemName]: val,
        });
    }}/>
    </div>);
};
export default SwitchFormItem;
